import { render } from "./VSelectOpenIndicator.vue?vue&type=template&id=108a054c"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/VSelectOpenIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "108a054c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('108a054c', __exports__)) {
    api.reload('108a054c', __exports__)
  }
  
  module.hot.accept("./VSelectOpenIndicator.vue?vue&type=template&id=108a054c", () => {
    api.rerender('108a054c', render)
  })

}


export default __exports__